import chunk from 'lodash/chunk';

export const RestrictCurrency = angular
    .module('app.directives.restrictCurrency', [])
    .directive('restrictCurrency', () => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, ele, attrs, ngModel) => {
                //group 1 returns all values in front of decimal and 2 decimals following
                var priceRegex = /^((\d*|,\d*)*(\.\d{0,2})?)/g;

                var formatCurrency = () => {
                    var value = ele.val();
                    var oldVal = value;
                    var cursor = ele[0].selectionEnd;
                    value = value.replace(/,/g, '');
                    if (value) {
                        var splitVal = new RegExp(priceRegex).exec(value.toString());

                        if (splitVal[1] != null && splitVal[1] !== '') {
                            var newVal = getCommaVal(splitVal[1]);
                            ele.val(newVal);
                            cursor += (newVal.length - oldVal.length >= 1 && cursor > newVal.indexOf(',')) ? 1 : 0;
                            // We've added a comma and updated our cursor position accordingly
                            ele[0].setSelectionRange(cursor, cursor);
                        } else {
                            ngModel.$setViewValue('');
                            ngModel.$render();
                            return false;
                        }
                    }

                    return false;
                };
                ele.on('input', formatCurrency);

                ngModel.$formatters.push((value) => {
                    if (value) {
                        var splitVal = new RegExp(priceRegex).exec(value.toString());

                        if (splitVal[1] != null && splitVal[1] !== '') {
                            var val = getCommaVal(splitVal[1]);
                            var decimalSplit = val.split('.');
                            if (!decimalSplit[1]) {
                                decimalSplit[1] = '00';
                            } else if (decimalSplit[1].length === 1) {
                                decimalSplit[1] += '0';
                            }

                            return decimalSplit.join('.');
                        }

                        ngModel.$setViewValue('');
                        ngModel.$render();
                        return value;
                    }

                    return value;
                });

                ngModel.$parsers.push((value) => {
                    var splitVal = new RegExp(priceRegex).exec(value.toString());
                    if (splitVal[1] != null && splitVal[1] !== '') {
                        return parseFloat(splitVal[1].replace(/,/g, ''));
                    }

                    ngModel.$setViewValue('');
                    ngModel.$render();
                    return value;
                });

                function getCommaVal(value) {
                    if (value === '' || value == null) {
                        return value;
                    }

                    var val = value.replace(/,/g, '');
                    var decSplit = val.toString().split('.');
                    var decValue = decSplit[1] || null;

                    var arr = decSplit[0].split('');
                    var res = '';
                    if (arr.length) {
                        var chunked = chunk(arr.reverse(), 3);

                        res = chunked[chunked.length - 1].reverse().join('');
                        for (var i = chunked.length - 2; i >= 0; i--) {
                            res += `,${chunked[i].reverse().join('')}`;
                        }
                    }

                    if (decSplit.length === 2) {
                        res += '.';
                    }

                    res += decValue || '';
                    return res;
                }
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/restrictCurrency.directive.js